import { MainView } from '@repo/ui/Views';
import { useUser } from '@repo/hooks/useUser';
import { POLICIES, Authorization } from '@/lib/Authorization';
import CreateUserForm from '../components/CreateUserForAccount';
import { FallbackCard } from '@repo/ui/Card';

const CreateUser = () => {
  const user = useUser();

  return (
    <MainView title={'Create new user'}>
      <Authorization
        policyCheck={POLICIES['user:create'](user)}
        fallbackView={
          <FallbackCard
            title="No Access"
            description="You do not have the permissions to create users."
          />
        }
      >
        <CreateUserForm />
      </Authorization>
    </MainView>
  );
};

export default CreateUser;
